import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import InlineModal from '../shared/InlineModal';

export default function ImageAspectRatioSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['warning', 'failed'].includes(result.status) && (
                    <>
                        <ImageRatioResult images={result.images} />

                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type ImageRatioResultProps = {
    images: {
        actual_aspect_ratio: number;
        displayed_aspect_ratio: number;
        displayed_height: number;
        displayed_width: number;
        natural_height: number;
        natural_width: number;
        src: string;
    }[];
};

function ImageRatioResult({ images }: ImageRatioResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See results list"
                modalTitle="Full list of images with incorrect aspect ratio"
                closeLabel="Close"
            >
                <div className="image-table">
                    <div className="image-table-row">
                        <div className="image-table-cell image">Image </div>
                        <div className="image-table-cell url">Url </div>
                        <div className="image-table-cell rendered-size">Displayed aspect ratio</div>
                        <div className="image-table-cell natural-size">Natural aspect ratio</div>
                    </div>
                    {images.map((image, idx) => {
                        const url = '...' + image.src.slice(-30);
                        return (
                            <div
                                className="image-table-row"
                                key={idx}
                            >
                                <div className="image-table-cell image">
                                    <img
                                        src={image.src}
                                        alt=""
                                    />
                                </div>
                                <div className="image-table-cell url">
                                    <a
                                        href={image.src}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {url}
                                    </a>
                                </div>
                                <div className="image-table-cell rendered-size">
                                    {image.displayed_width}x{image.displayed_height} ({image.displayed_aspect_ratio.toFixed(2)})
                                </div>
                                <div className="image-table-cell natural-size">
                                    {image.natural_width}x{image.natural_height} ({image.actual_aspect_ratio.toFixed(2)})
                                </div>
                            </div>
                        );
                    })}
                </div>
            </InlineModal>
        </div>
    );
}
